import { useMemo } from 'react';
import { useAppSelector } from '@/shared/model';
import type { PresetViewType } from '../api/types';
import { filterPresetsByViewType } from '../libs/filterPresetsByViewType';
import { selectPresets } from './slice';
import type { SavedPresetRecord, Validator } from './types';

export function usePresetsForViewType<T>(
  viewType: PresetViewType,
  validator: Validator,
): SavedPresetRecord<T>[] {
  const allPresets = useAppSelector(selectPresets);
  return useMemo(
    () => filterPresetsByViewType(allPresets, viewType, validator),
    [allPresets, viewType, validator],
  );
}
